import ApplicationController from '../application_controller'

class EnableTwoFactorController extends ApplicationController {
  connect () {
    this.element.addEventListener('change', this.handleMethodUpdate.bind(this))
  }

  handleMethodUpdate () {
    const strategy = this.element.value
    const secret = this.element.dataset.secret
    $('.two_factor_codes').addClass('hidden')

    if (['google_auth', 'microsoft_auth'].includes(strategy) && secret) {
      $('.two_factor_codes#google_auth').removeClass('hidden')
    }

    if (strategy === 'sms' && secret) {
      $('.two_factor_codes#sms').removeClass('hidden')
    }

    const form = document.querySelector('form.edit-user-form')
    form.requestSubmit()
  }
}

export default EnableTwoFactorController
